export default function Input({ location, onChangeLocation }) {
  return (
    <div>
      <input
        type="text"
        placeholder="search for location..."
        value={location}
        onChange={(e) => onChangeLocation(e)}
      />
    </div>
  );
}
